const BEAUTY_INSIDER_TERMS_LINK = '/beauty/terms-conditions-beauty-insider';
const USNoticeIncentiveLink = '/beauty/privacy-policy#USNoticeIncentive';
const TEXT_TERM_LINK = '/beauty/sms-terms-and-conditions';
const PRIVACY_POLICY_LINK = '/beauty/privacy-policy';
const TERMS_OF_USE_LINK = '/beauty/terms-of-use';
const CHATGPT_PRIVACY_POLICY_LINK = 'https://openai.com/policies/privacy-policy/';

export {
    BEAUTY_INSIDER_TERMS_LINK, USNoticeIncentiveLink, TEXT_TERM_LINK, PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK, CHATGPT_PRIVACY_POLICY_LINK
};
